import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import { GameProvider } from './contexts/GameContext';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  
  <GameProvider>
      <React.StrictMode>
        <App />
      </React.StrictMode>
  </GameProvider>
);